import { IJob } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';

export const JOBS_ACTION_NAMES = {
  JOB_STARTED: 'JOBS_ACTION_NAMES.JOB_STARTED',
  JOB_START_FAILED: 'JOBS_ACTION_NAMES.JOB_START_FAILED',
  JOB_PROCESSING_FAILED: 'JOBS_ACTION_NAMES.JOB_PROCESSING_FAILED',
  JOB_STATUS_CHANGED: 'JOBS_ACTION_NAMES.JOB_STATUS_CHANGED',
};

type JobContext = any; // could be any additional data defined by a user of job actions

export interface JobEventPayload<S> {
  context: JobContext;
  fileId?: string;
  job: IJob<S>;
}

export interface JobStartFailedPayload {
  error: any;
  context: JobContext;
}

export interface JobProcessingFailedPayload<S> {
  job: IJob<S>;
  error: any;
  context: JobContext;
}

export const jobStarted = <S>(payload: JobEventPayload<S>) => ({
  type: JOBS_ACTION_NAMES.JOB_STARTED,
  payload,
});

export const jobStartFailed = <S>(payload: JobStartFailedPayload) => ({
  type: JOBS_ACTION_NAMES.JOB_START_FAILED,
  payload,
});

export const jobProcessingFailed = <S>(
  payload: JobProcessingFailedPayload<S>,
) => ({
  type: JOBS_ACTION_NAMES.JOB_PROCESSING_FAILED,
  payload,
});

export const jobStatusChanged = <S>(payload: JobEventPayload<S>) => ({
  type: JOBS_ACTION_NAMES.JOB_STATUS_CHANGED,
  payload,
});
